import { Decoration, DecorationSet } from 'prosemirror-view';
import { Plugin } from 'prosemirror-state';
import { Extension } from '@tiptap/core';
import { PluginKey } from '@tiptap/pm/state';
import { Events } from '../events';


export const LocationMarkerExt = Extension.create({
  name: 'LocationMarker',
  addProseMirrorPlugins() {
    return [LocationMarkerPlugin]
  },

  // @ts-ignore
  addCommands() {
    
    return {

      addMarkToFix: color => ({editor, chain, tr}) => {
        const { view, state } = editor
        const { from, to } = view.state.selection
        const text = state.doc.textBetween(from, to, '\n')
        const transaction = editor.state.tr.setMeta('charizard.LocationMarker', {
          add: true, from, to, text
        });
        editor.view.dispatch(transaction);

           
        Events.dispatch(Events.MARK_FOR_FIX, { 
          text, from, to
        })        
      },

      withdrawToFix: () => ({ editor, tr }) => {
        const transaction = editor.state.tr.setMeta('charizard.LocationMarker', { remove: true });
        editor.view.dispatch(transaction);
        Events.dispatch(Events.MARK_FOR_FIX, null)        
      },

      markToFix: color => ({editor, chain, tr}) => {
        chain().withdrawToFix().addMarkToFix().run()
      },

    }
  },


});

export const LocationMarkerPlugin = new Plugin({

  key: new PluginKey('"charizard.LocationMarker"'),
  props: {
    decorations(state) {
      return this.getState(state);
    },
  },
  state: {
    init() {
      return DecorationSet.empty;
    },
    apply(tr, set) {
      set = set.map(tr.mapping, tr.doc);
      const action = tr.getMeta("charizard.LocationMarker");
      if (action && action.add) {
        const deco = Decoration.inline(action.from, action.to, {
          nodeName: 'span', 
          class: 'toFix',
          // style: 'background-color: red'
        });

        return set.add(tr.doc, [deco]);
      }
      if (action && action.remove) {
        return DecorationSet.empty;
      }
      return set;
    },
  },
});